// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"f73fa4ed","145":"38de73d6","334":"558c96ef","603":"ae52fc19","814":"2689c521","818":"9455b14e","922":"6e74f445"}[chunkId] + ".chunk.js";
};